<template>
	<div class='detail-box'>
		<div class="detail-row">
			<div class="left-box">
				<span class="title">商品名称：</span>
				<span class="info">{{productname}}</span>
			</div>
			<div class="right-box">
				<span class="title">规格：</span>
				<span class="info">{{spec}}</span>
			</div>
		</div>
		<div class="detail-row">
			<div class="left-box">
				<span class="title">适用店铺：</span>
				<span class="info">{{shopname}}</span>
			</div>
			<div class="right-box">
				<span class="title">销售价格：</span>
				<span class="info"><span v-if="price !== -1">¥</span>{{price === -1 ? '' : price}}</span>
			</div>
		</div>
		<div class="table-box">
			<el-table
				size='mini'
				class="grid-content"
				:data="tableData"
				:height="tableHeight"
				ref="table"
				border>
				<el-table-column
					label="客户等级"
					prop='levelname'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="商品价格"
					prop='levelprice'
					min-width="180"
					align="center">
					<template slot-scope="scope">
						<el-input v-model="scope.row.levelprice" @blur="priceBlur(scope.$index)" size="mini"></el-input>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button size='small' type='primary' class="fx-big-btn" plain @click="cancel">取消</el-button>
			<el-button size='small' type='primary' class="fx-big-btn" plain @click="save">保存</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'editModal',
	props: {
		rpasid: String
	},
	data () {
		return {
			shopname: '',
			productname: '',
			price: '',
			spec: '',
			code: '',
			speccode: '',
			tableData: [],
			tableHeight: '100%'
		}
	},
	created () {
		this.getInfo()
	},
	methods: {
		getInfo () {
			let params = {
				rpasId: this.rpasid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/productLevelPriceInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.price = res.data.price
					this.productname = res.data.productname
					this.shopname = res.data.shopname
					this.spec = res.data.spec
					this.speccode = res.data.speccode
					this.code = res.data.code
					this.tableData = res.data.levelPriceList
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		priceBlur (index) {
			this.tableData[index].levelprice = this.tableData[index].levelprice.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.tableData[index].levelprice = this.tableData[index].levelprice.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.tableData[index].levelprice = this.tableData[index].levelprice.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.tableData[index].levelprice = this.tableData[index].levelprice.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			this.tableData[index].levelprice = this.tableData[index].levelprice.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
			if (this.tableData[index].levelprice !== '') {
				this.tableData[index].levelprice = this.$fxUtils.toFixedSHW(this.tableData[index].levelprice, 2)
			}
		},
		save () {
			let params = {
				rpasId: this.rpasid,
				productLevelPriceDTOS: this.tableData
			}
			let loggerText = `店铺【 ${this.shopname} 】下的【${this.productname}】【${this.speccode}】`
			let arr = []
			this.tableData.forEach(item => {
				let text = item.levelname + '价格为' + (item.levelprice === '' ? '空' : item.levelprice)
				arr.push(text)
			})
			loggerText = loggerText + arr.join(',')
			const logger = this.$fxLogger.createInfo('goods.grade_price.edit', loggerText)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/productLevelPrice/saveOrUpdate`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$emit('cancel', false)
					this.$message.success('保存成功')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		cancel () {
			this.$emit('cancel')
		}
	}
}
</script>

<style lang="stylus" scoped>
.table-box{
	flex: 1
}
.detail-row{
	height: 40px;
	display: flex;
	flex: row;
	align-items: center;
	justify-content: center
}
.left-box{
	flex: 3;
	height: 20px;
	overflow: hidden;
	text-overflow:ellipsis;
	white-space: nowrap;
}
.info{
	font-size: 12px;
	font-family: Microsoft YaHei;
	color: #333333;
}
.title{
	font-size: 12px;
	font-family: Microsoft YaHei;
	font-weight: bold;
	color: #333333;
}
.right-box{
	flex: 1;
	overflow: hidden;
	text-overflow:ellipsis;
	white-space: nowrap;
}
.detail-box{
    padding 0px 0px 10px 0px
    display: flex;
    height:400px;
    overflow-y:auto;
    text-align:left ;
	flex-direction: column
}
.dialog-footer{
    margin-top:20px;
    text-align:center;
	.el-button{
		margin-right :15px
	}
}
</style>
